import React, { useEffect, useRef, useState } from 'react';
;
export var Dropdown = function (_a) {
    var title = _a.title, align = _a.align, className = _a.className, forceClose = _a.forceClose, setForceClose = _a.setForceClose, onClose = _a.onClose, _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.buttonClassName, buttonClassName = _c === void 0 ? '' : _c, children = _a.children;
    var dropdownRef = useRef(null);
    var dropdownContentRef = useRef(null);
    var _d = useState(false), show = _d[0], setShow = _d[1];
    var _e = useState(true), firstLoad = _e[0], setFirstLoad = _e[1];
    /**
     * constructor
     */
    useEffect(function () {
        var hideDropdown = function (e) {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                if (dropdownContentRef.current) {
                    dropdownContentRef.current.scrollTop = 0;
                }
                setShow(false);
            }
        };
        document.addEventListener('click', hideDropdown);
        return function () {
            document.removeEventListener('click', hideDropdown);
        };
    }, []);
    // closing dropdown in case if clicked element
    // contains class called close-dropdown
    useEffect(function () {
        if (forceClose) {
            setShow(false);
        }
    }, [forceClose]);
    useEffect(function () {
        if (show && setForceClose) {
            setForceClose(false);
        }
        //  executes on close callback if it is provided
        if (!firstLoad && !show && onClose) {
            onClose();
        }
        firstLoad && setFirstLoad(false);
    }, [show]);
    var onToggle = function (e) {
        e.preventDefault();
        if (dropdownRef.current) {
            var dropdownContent = dropdownRef.current.lastElementChild;
            var dropdownButton = dropdownRef.current.firstElementChild;
            if (dropdownContent && dropdownButton) {
                dropdownContent.style.minWidth = dropdownButton.offsetWidth + 'px';
            }
        }
        // hiding in case if disabled is true
        if (disabled) {
            setShow(false);
            return;
        }
        setShow(!show);
    };
    return (React.createElement("div", { className: "dropdown " + (className || ''), ref: dropdownRef },
        React.createElement("button", { className: "dropdown-button " + buttonClassName + " " + (show ? 'active' : ''), onClick: onToggle }, title),
        React.createElement("div", { className: "dropdown-content " + (align || 'left') + " " + (show ? 'show' : ''), ref: dropdownContentRef }, children)));
};
